import axiosInsAcademy from '@/api/axios-ugems-academy';

export const GET_TRAINING_CATEGORIES = (params) => {
    const queryParams = params || { limit: '', search: '' };
    const queryString = new URLSearchParams(queryParams).toString();
    return axiosInsAcademy.get(`/training-categories?${queryString}`);
}
